<div class="card shadow mb-4">
  <div class="card-body">
    @if (!thingType) {
      <h4>Select a Thing Type</h4>
    } @else {
      <app-ngx-table-with-query-params-persistence
        [data]="exports"
        [configuration]="configuration"
        [columns]="columns"
        [filtersFormGroup]="formGroupLocalFilters"
        [filtersTemplate]="filters"
      >
        <ng-template let-untypedItem>
          <!-- Allows IDEs to correctly infer the object type to provide completion and checks -->
          @if (typedOngoingStatisticExportFile(untypedItem); as item) {
            <td class="align-middle">
              <strong>{{ item.date | replace: ' ' : '&nbsp;' }}</strong>
            </td>
            <td class="align-middle">
              <div class="d-flex gap-2 align-middle">
                <span class="h6 mb-0">{{ item.filename | replace: thingType + '/' : '' }}</span>
                <span>
                  <span
                    class="badge"
                    [ngClass]="{
                        'badge-success': item.manual,
                        'badge-primary': !item.manual,
                      }"
                  >
                    {{ item.manual ? 'Manual' : 'Automatic' }}
                  </span>
                </span>
              </div>
            </td>
            <td class="align-middle">
              {{ item.size | formatBytes }}
            </td>
            <td class="align-middle">
              <button
                class="btn btn-success"
                (click)="downloadExportFile(item.filename)"
              >
                <i class="fas fa-download"></i>
              </button>
            </td>
          }
        </ng-template>
      </app-ngx-table-with-query-params-persistence>

      <ng-template #filters>
        <ng-container [formGroup]="formGroupLocalFilters">
          <th scope="col">
            <input
              class="form-control"
              type="text"
              placeholder="Date"
              formControlName="date"
            />
          </th>
          <th scope="col">
            <input
              class="form-control"
              type="text"
              placeholder="Filename"
              formControlName="filename"
            />
          </th>
        </ng-container>
      </ng-template>
    }
  </div>
</div>
